// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-track-type_container__EaOFU","credits":"nav-track-type_credits__7fAtM","icon":"nav-track-type_icon__5WetT","switch":"nav-track-type_switch__W8Pdq"};